<div mat-dialog-content class="connect-wallet-dialog">
  <div class="py-3 px-2">
    <app-connect-buttons
      [metamaskDisabled]="disableMetamaskButton$ | async"
      [metamaskPresent]="isMetamaskExtensionAvailable$ | async"
      [showEkcOption]="showEkcOption"
      (connectTo)="login($event)"></app-connect-buttons>
  </div>
</div>
